import { z } from 'zod';

export enum WasteProfileStatus {
  NOT_SUBMITTED = 'Not Submitted',
  SUBMITTED = 'Submitted',
  ACTION_REQUIRED = 'Action Required',
  APPROVED = 'Approved',
  EXPIRING = 'Expiring',
  EXPIRED = 'Expired',
  INCOMPLETE = 'Incomplete',
  PENDING_SIGNATURE = 'Pending Signature',
  REJECTED = 'Rejected',
}

export const wasteProfileStatusOptions = [
  WasteProfileStatus.NOT_SUBMITTED,
  WasteProfileStatus.SUBMITTED,
  WasteProfileStatus.ACTION_REQUIRED,
  WasteProfileStatus.APPROVED,
  WasteProfileStatus.EXPIRING,
  WasteProfileStatus.EXPIRED,
  WasteProfileStatus.INCOMPLETE,
  WasteProfileStatus.PENDING_SIGNATURE,
] as const;

export const WasteProfileStatusSchema = z.enum(wasteProfileStatusOptions);

export type WasteProfileStatusOptions = z.infer<
  typeof WasteProfileStatusSchema
>;
